import { render, staticRenderFns } from "./RecommendationForm.vue?vue&type=template&id=bd05917a"
import script from "./RecommendationForm.vue?vue&type=script&lang=js"
export * from "./RecommendationForm.vue?vue&type=script&lang=js"
import style0 from "./RecommendationForm.vue?vue&type=style&index=0&id=bd05917a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports